/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

import { accent } from '../../../styles/colors'
import { vFlex } from '../../../styles/style-helpers'

export const FoldedTextEl = styled.div`
  position: relative;
  width: 100%;
  ${vFlex};
  align-items: flex-end;

  p {
    width: 100%;
  }

  button {
    color: ${accent};
    padding: 0.5em 0;
  }
`
